import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            焦点专题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            精选策划内容
          </h2>
          <p className="mt-2 text-sm text-foreground-600">编辑甄选，深度解读好片背后的故事</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item) => (
            <div key={item.id} className="group cursor-pointer bg-background-100 rounded-xl overflow-hidden">
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-950/60 backdrop-blur-sm text-background-50 text-xs font-medium">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
                <span className="mt-3 inline-block text-xs text-foreground-500">{item.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}